import { ReactElement, useMemo } from 'react';
import Stack from '@mui/material/Stack';

import { useSubscriptionFeatures } from '~hooks/useSubscriptionFeatures';
import NewFeatureBagde from '~components/NewFeatureBagde';

import { AccessFeatureBadgeProps } from './types';
import {
  AccessFeatureBadgeRoot,
  AccessFeatureBadgeNextPlanChip,
} from './styles';

const AccessFeatureBadge = ({
  validFeature,
  availableToDate,
  showChip = true,
  openAccessFeatureModalOnClickChip = false,
  fullWidth = false,
  translateY = '-50%',
  marginRightShow,
  activeForVersion,
  children,
}: AccessFeatureBadgeProps): ReactElement => {
  const { validateFeatureAccess, validateFeatureAvailableToDate } =
    useSubscriptionFeatures();

  const isDemo = useMemo(
    () =>
      !validateFeatureAccess(validFeature) &&
      validateFeatureAvailableToDate(availableToDate),
    [
      availableToDate,
      validFeature,
      validateFeatureAccess,
      validateFeatureAvailableToDate,
    ],
  );

  const hasAccessFeature = useMemo(
    () => validateFeatureAccess(validFeature),
    [validFeature, validateFeatureAccess],
  );

  return (
    <AccessFeatureBadgeRoot
      fullWidth={fullWidth}
      badgeContent={
        <Stack spacing={1} direction="row">
          {(isDemo || !hasAccessFeature) && (
            <AccessFeatureBadgeNextPlanChip
              validFeature={validFeature}
              availableToDate={availableToDate}
              openAccessFeatureModalOnClick={openAccessFeatureModalOnClickChip}
            />
          )}

          {activeForVersion && (
            <NewFeatureBagde activeForVersion={activeForVersion} />
          )}
        </Stack>
      }
      invisible={!showChip}
      marginRightShow={marginRightShow}
      translateY={translateY}
    >
      {children}
    </AccessFeatureBadgeRoot>
  );
};

export default AccessFeatureBadge;
